import React from 'react';
import IncomeResolutionWorkspace from './IncomeResolutionWorkspace';

/** 수입결의승인 */
export default function IncomeResolutionApprove() {
  return <IncomeResolutionWorkspace screenMode="approve" />;
}
